<template>
  <portal to="editor-link-modal">
    <modal
      name="linkModal"
      adaptive
      :pivotY="0.1"
      :width="400"
      :height="160"
      classes="wf-shadow-xl wf-rounded-lg wf-bg-white wf-p-4"
      @before-open="beforeOpen"
      @closed="closed"
    >
      <div class="wf-flex wf-flex-col wf-h-full">
        <div class="wf-flex wf-flex-wrap wf--mx-2 wf-items-center">
          <div class="wf-flex-1 wf-px-2">
            <label for="url" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">URL address</label>
            <input
              v-model="link"
              id="url"
              type="text"
              class="wf-mt-1 focus:wf-outline-none wf-bg-gray-200 wf-h-10 wf-text-gray-700 wf-rounded-md wf-text-sm wf-px-2 wf-w-full"
            />
          </div>
          <div class="wf-px-2">
            <label for="target" class="wf-inline-block wf-pt-5">
              <input id="target" type="checkbox" v-model="blank">
              <span class="wf-text-gray-600 wf-inline-block wf-ml-2 wf-text-xs wf-font-semibold wf-uppercase">open in new tab</span>
            </label>
          </div>
        </div>
        <div class="wf-mt-auto wf-flex wf-justify-end">
          <button
            class="wf-text-xs wf-uppercase wf-w-32 wf-h-10 wf-rounded-md hover:wf-bg-gray-200 wf-text-gray-700 hover:wf-text-gray-800 wf-font-bold"
            @click.prevent="$modal.hide('linkModal')"
          >Cancel</button>
          <button
            @click.prevent="saveLink"
            class="wf-ml-5 wf-text-xs wf-uppercase wf-w-32 wf-h-10 wf-rounded-md wf-bg-blue-200 hover:wf-bg-blue-300 wf-text-blue-700 hover:wf-text-blue-800 wf-font-bold"
          >Save</button>
        </div>
      </div>
    </modal>
  </portal>
</template>

<script>
  import { Portal } from 'portal-vue'
  export default {
    components: {Portal},
    data() {
      return {
        link: null,
        blank: false
      }
    },
    methods: {
      beforeOpen() {
        this.resetForm()
      },
      closed() {
        this.resetForm()
      },
      resetForm() {
        this.link = null
        this.blank = false
      },
      saveLink() {
        if (! this.link) {
          alert('No link added')
          return
        }
        this.$emit('linkSaved', {
          link: this.link,
          blank: this.blank
        })
        this.$modal.hide('linkModal')
      }
    }
  }
</script>